import { TweenLite } from "gsap";
const Flickity = require('flickity')

export default {
  init() {
    if (window.innerWidth < 1024) {
      const $related = $('.related')
      $related
        .find('.product-card')
          .removeClass('product-card--primary')
          .addClass('product-card--secondary col-12 col-md-4')

      TweenLite.set($related, { autoAlpha: 1 })
    }

    const gallery = new Flickity(
      $('.woocommerce-product-gallery__wrapper').get(0),
      {
        cellSelector: '.woocommerce-product-gallery__image',
        prevNextButtons: false,
        wrapAround: true,
        lazyLoad: 2,
      }
    )

    setTimeout(() => {
      gallery.resize()
    }, 1000);

  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/single_product.js